export enum FlowType {
    BUY_BOOK="buy_book",
    COPY_BOOK="copy_book",
    TOPUP_BALANCE="top_up_balance",
    COPY_CARD="copy_card",

    BUY_CALENDAR="buy_calendar",
    BUY_COUNTRY="buy_country",
    SEND_GIFT="send_gift",
    SEND_PRODUCT_CARD="send_product_card",
    CREATE_CARD="create_card",
    BUY_CARD_PRINT="buy_card_print",
    CREATE_PRODUCT_CARD="create_product_card",
    RELEASE_PRODUCT_CARD="release_product_card",
    BUY_POSTER="buy_poster",
    BUY_SUBSCRIPTION="buy_subscription",
    GIFT_SUBSCRIPTION="gift_subscription",
    BUY_PRINTED_SUBSCRIPTION="buy_printed_subscription",
    GIFT_PRINTED_SUBSCRIPTION="gift_printed_subscription",
}

export interface IFlowItem {
    component: React.FC<any>
    props: any
}

export type IFlow = IFlowItem[]

export type IFlowSteps = Record<string, number>;export enum FlowType {
    BUY_BOOK="buy_book",
    COPY_BOOK="copy_book",
    TOPUP_BALANCE="top_up_balance",
    COPY_CARD="copy_card",

    BUY_CALENDAR="buy_calendar",
    BUY_COUNTRY="buy_country",
    SEND_GIFT="send_gift",
    SEND_PRODUCT_CARD="send_product_card",
    CREATE_CARD="create_card",
    BUY_CARD_PRINT="buy_card_print",
    CREATE_PRODUCT_CARD="create_product_card",
    RELEASE_PRODUCT_CARD="release_product_card",
    BUY_POSTER="buy_poster",
    BUY_SUBSCRIPTION="buy_subscription",
    GIFT_SUBSCRIPTION="gift_subscription",
    BUY_PRINTED_SUBSCRIPTION="buy_printed_subscription",
    GIFT_PRINTED_SUBSCRIPTION="gift_printed_subscription",
}

export interface IFlowItem {
    component: React.FC<any>
    props: any
}

export type IFlow = IFlowItem[]

export type IFlowSteps = Record<string, number>;